import { createTheme, palette } from '@dentalux/ui-library-core/constants'
import { shadows } from '@dentalux/ui-library-core/themes/shadows'
import { typography, MuiTypography } from '@dentalux/ui-library-core/themes/typography'
import { MuiButton } from '@dentalux/ui-library-core/themes/button'
import { MuiAlert } from '@dentalux/ui-library-core/themes/alert'
import { MuiFormHelperText } from '@dentalux/ui-library-core/themes/form-helper-text'

import colors from './colors'

export const createAppTheme = (mode: 'light' | 'dark' = 'light') =>
  createTheme({
    shadows,
    typography,
    components: {
      MuiTypography,
      MuiButton,
      MuiAlert,
      MuiFormHelperText,
    },
    palette: {
      ...palette,
      mode,
      text: {
        primary: colors.grey[800],
      },
      background: {
        default: colors.white,
      },
      secondary: {
        main: colors.secondary,
        ...palette.secondary,
      },
      primary: {
        main: colors.primary,
        ...palette.primary,
      },
      grey: colors.grey,
      error: colors.error,
    },
  })

const theme = createAppTheme('light')

export default theme
